import { useNavigate } from "react-router-dom";
import { getCurrentClientConfig } from "config/clientConfig";
import { useTranslation } from "context/LanguageContext";
import { getSavedOrders } from "services/orderTrackingStorage";
import OrderPageLayout from "features/orders/components/OrderPageLayout";
import OrderPageHeader from "features/orders/components/OrderPageHeader";

export default function OrdersPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const orders = getSavedOrders(getCurrentClientConfig().tenantId);

  return (
    <OrderPageLayout
      header={<OrderPageHeader title={t("myOrders")} navigation="back-home" />}
    >
      {orders.length === 0 ? (
        <div className="bg-white border rounded-xl p-8 text-center text-gray-600">
          {t("noSavedOrders")}
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((order) => (
            <button
              key={order.orderId}
              onClick={() => navigate(`/orders/${order.orderId}`)}
              className="w-full bg-white border rounded-xl p-5 text-start hover:border-blue-500 transition"
            >
              <span className="block font-semibold">{t("orderNumber")}: #{order.orderId}</span>
              <span className="block text-sm text-gray-500 mt-1">
                {new Date(order.createdAt).toLocaleString()}
              </span>
            </button>
          ))}
        </div>
      )}
    </OrderPageLayout>
  );
}
